import { configureStore } from '@reduxjs/toolkit';
import transactionsReducer from '@/app/store/transactionsSlice';
import rewardsReducer from '@/app/store/rewardsSlice';
import partnersReducer from '@/app/store/partnersSlice';
import offersReducer from '@/app/store/offersSlice';
import fulfillmentsReducer from '@/app/store/fulfillmentsSlice';
import jobsReducer from '@/app/store/jobsSlice';
import paperJournalReducer from '@/app/store/paperJournalSlice';

// Create Redux store
export const store = configureStore({
  reducer: {
    transactions: transactionsReducer,
    rewards: rewardsReducer,
    partners: partnersReducer,
    offers: offersReducer,
    fulfillments: fulfillmentsReducer,
    jobs: jobsReducer,
    paperJournal: paperJournalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

